import { atom, useAtomValue } from 'jotai';

export const devMarketplaceExternalIdAtom = atom('');

export const useMarketplaceExternalId = (externalId?: string): string => {
  const devExternalId = useAtomValue(devMarketplaceExternalIdAtom);

  return devExternalId || externalId || '';
};
